import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getListProperties } from '../../Redux/Actions/actions';
import CardActiveAdmin from '../CardActiveAdmin/CardActiveAdmin';
import style from './CardActiveAdminContainer.module.css';

const CardActiveAdminContainer = ({ activeProperties, getListProperties }) => {
  const [filter, setFilter] = useState('/properties/active?cerrado=false');
  const [search, setSearch] = useState('');

  // Fetch data whenever filter changes
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getListProperties(filter);
    }, 300); // Espera para evitar múltiples requests al tipear

    return () => clearTimeout(delayDebounce);
  }, [filter, getListProperties]);

  // Update search term
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);

    let endpoint = '/properties/active?cerrado=false';
    if (value) {
      endpoint += `&search=${value}`;
    }
    setFilter(endpoint);
  };

  // Change filter
  const handleFilterChange = (endpoint) => {
    setSearch('');
    setFilter(endpoint);
  };

  return (
    <div>
      {/* Barra de búsqueda */}
      <div className={style.searchBar}>
        <input
          type="text"
          placeholder="Buscar por ID..."
          value={search}
          onChange={handleSearchChange}
          className={style.searchInput}
        />
      </div>

      {/* Botones de filtro */}
      <div className={style.filterButtons}>
        <button
          className={style.buttonFilter}
          onClick={() => handleFilterChange('/properties/active?cerrado=false')}
        >
          Todas
        </button>
        <button
          className={style.buttonFilter}
          onClick={() =>
            handleFilterChange('/properties/active?cerrado=false&orderBy=updatedAt')
          }
        >
          Actualizadas
        </button>
        <button
          className={style.buttonFilter}
          onClick={() => handleFilterChange('/properties/active?cerrado=true')}
        >
          Cerradas
        </button>
      </div>

      {/* Listado de propiedades */}
      <div className="card-deck">
        <h3>Cantidad: {activeProperties.length} Publicaciones</h3>

        {activeProperties.length === 0 ? (
          <p>No se encontraron propiedades.</p>
        ) : (
          activeProperties.map((property) => (
            <CardActiveAdmin key={property.id} property={property} />
          ))
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  activeProperties: Array.isArray(state.activeProperties) ? state.activeProperties : [],
});

export default connect(mapStateToProps, { getListProperties })(CardActiveAdminContainer);
